import React from "react";
import PropTypes from "prop-types"
import {Table} from 'antd';
import {NavLink} from "react-router-dom"
import {defaultPagination} from "../../util/Util"


const LovResultTable = ({dataSource, loading}) => {
    const columns = [
        {title: 'Label', dataIndex: 'lovType', key:'lovType',render: (text) => <NavLink to={`/lovResult/${text}`}>{text}</NavLink>}
    ];


    return (
        <Table
            dataSource={dataSource}
            loading={loading}
            columns={columns}
            bordered
            rowKey={record => record.id}
            pagination={defaultPagination()}
        />
    );
};
LovResultTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    compact: PropTypes.bool.isRequired
};

export default LovResultTable



// WEBPACK FOOTER //
// ./src/js/lovs/result/LovResultTable.js